import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type SMBWhyTrustNerdWalletProps = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export function SMBWhyTrustNerdWalletBullet({ props }: SMBWhyTrustNerdWalletProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        div: {
          marginBottom: '0 !important',
        },
      }}
    >
      <Typography
        sx={{
          color: 'greens.main',
          marginRight: 0.5,
          fontSize: '20px',
        }}
      >
        <CheckCircleIcon color="inherit" />
      </Typography>
      <StructuredContentRenderer doc={props.children} />
    </Box>
  );
}
